import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const isNumberInput = (el) => el?.tagName === "INPUT" && el.type === "number";
document.addEventListener(
  "wheel",
  (e) => {
    if (isNumberInput(e.target) && document.activeElement === e.target) e.target.blur();
  },
  { passive: true },
);
document.addEventListener("keydown", (e) => {
  if (isNumberInput(e.target) && (e.key === "ArrowUp" || e.key === "ArrowDown")) e.preventDefault();
});

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => { navigator.serviceWorker.register("/sw.js").catch(() => {}); });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
